import * as React from 'react';
import { useApplicationContext } from '../../ApplicationContext';
import { XmlUnloadingBanner } from '../../../components/XmlUnloadingBanner';
import { jsx as _jsx } from "react/jsx-runtime";
export var XmlUnloadingBannerContainer = function XmlUnloadingBannerContainer() {
  var _useApplicationContex = useApplicationContext(),
    config = _useApplicationContex.config;
  var url = config.get('xmlImportRequirements.entryUrl');
  if (!url) {
    return null;
  }
  return /*#__PURE__*/_jsx(XmlUnloadingBanner, {
    url: url
  });
};